__webpack_require__.p = "https://uat-seguros.barkibu.com/";